import { useMutation } from '@tanstack/react-query';
import { approveImport } from 'config/requests/bankOperations';

export function useApproveImport() {
  return useMutation({
    mutationFn: ({ id }: { id: string }) => approveImport(id),
  });
}
